export const getItem = (key) => {
  if (localStorage.getItem(key)) {
    return localStorage.getItem(key);
  } else {
    return undefined;
  }
};

export const setItem = (key, value) => {
  return localStorage.setItem(key, value);
};

export const setItemWithExpiry = (key, value, ttlInMinutes) => {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttlInMinutes * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getItemWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (err) {
    localStorage.removeItem(key);
    return null;
  }
};

export const removeItem = (key) => {
  return localStorage.removeItem(key);
};

// New utility functions for sorting model weightages
export const setLocalSortingModelWeightages = (weightages) => {
  try {
    const data = {
      percentageWeightages: weightages,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('sortingModelWeightages', JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Error saving sorting model weightages:', error);
    return false;
  }
};

export const getSortingModelWeightages = () => {
  try {
    const data = localStorage.getItem('sortingModelWeightages');
    if (!data) return null;
    
    const parsed = JSON.parse(data);
    return parsed.percentageWeightages || null;
  } catch (error) {
    console.error('Error loading sorting model weightages:', error);
    return null;
  }
};

export const setSortingModelSelections = (selections) => {
  try {
    const data = {
      selectedOptions: selections,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem('sortingModelSelections', JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Error saving sorting model selections:', error);
    return false;
  }
};

export const getSortingModelSelections = () => {
  try {
    const data = localStorage.getItem('sortingModelSelections');
    if (!data) return null;
    
    const parsed = JSON.parse(data);
    return parsed.selectedOptions || null;
  } catch (error) {
    console.error('Error loading sorting model selections:', error);
    return null;
  }
};

export const clearSortingModelData = () => {
  try {
    localStorage.removeItem('sortingModelWeightages');
    localStorage.removeItem('sortingModelSelections');
    return true;
  } catch (error) {
    console.error('Error clearing sorting model data:', error);
    return false;
  }
};
